import React from "react";
import { TwitterShareButton } from "react-share";
import { Twitter, MessageCircle, Facebook, X } from "react-feather";

function SharePage() {
  const shareUrl = window.location.href;
  const title = "Check out this amazing Product!";

  // Handler for Facebook (Direct URL Sharer)
  const shareToFacebook = (e) => {
    e.preventDefault();
    const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
    window.open(fbUrl, "facebook-share-dialog", "width=800,height=600");
  };

  return (
    <div style={styles.container}>
      {/* Facebook - Now consistent with other circles */}
      <a
        href="#!"
        onClick={shareToFacebook}
        style={styles.circle}
        title="Share on Facebook"
      >
        <Facebook size={15} color="black" />
      </a>

      {/* WhatsApp */}
      <a
        href={`https://api.whatsapp.com/send?text=${encodeURIComponent(title + " " + shareUrl)}`}
        target="_blank"
        rel="noopener noreferrer"
        style={styles.circle}
        title="Share on WhatsApp"
      >
        <MessageCircle size={15} color="black" />
      </a>

      {/* Twitter */}
      <TwitterShareButton url={shareUrl} title={title} style={styles.circle}>
        <X size={15} color="black" />
      </TwitterShareButton>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    gap: "12px", // Slightly tighter gap for a cleaner look
    justifyContent: "start",
    alignItems: "center",
    marginTop: "20px",
  },
  circle: {
    backgroundColor: "#FFC800",
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textDecoration: "none",
    cursor: "pointer",
    border: "none", // Reset for buttons
    padding: 0,     // Reset for buttons
    transition: "all 0.2s ease-in-out",
  },
};

export default SharePage;